import Swiper from "swiper";
import {Navigation} from "swiper/modules";

export function initProfileSlider(wrapper = document) {
    const sliderContainers = wrapper.querySelectorAll(".js-profile-slider");

    if (sliderContainers.length === 0) return;

    // Offset richtet den ersten/letzten Kopf an der container--large-Kante aus,
    // waehrend der Slider full-bleed laeuft (Inhalt laeuft an der Bildschirmkante
    // aus statt hart im Container abgeschnitten zu werden).
    const containerLargeWidth = 1764;
    const calcOffset = () => {
        const windowWidth = window.innerWidth;
        const padding = windowWidth >= 1250 ? 32 : 24;
        if (windowWidth > containerLargeWidth) {
            return (windowWidth - (containerLargeWidth - 2 * padding)) / 2;
        }
        return padding;
    };

    sliderContainers.forEach(slider => {
        const swiper = new Swiper(slider, {
            modules: [Navigation],
            speed: 400,
            slidesPerView: "auto",
            spaceBetween: 16,
            centeredSlides: false,
            // Zentriert die Koepfe, wenn sie alle passen; sonst links startend + swipebar.
            centerInsufficientSlides: true,
            watchOverflow: true,
            slidesOffsetBefore: calcOffset(),
            slidesOffsetAfter: calcOffset(),
            navigation: {
                nextEl: slider.parentElement.querySelector('.swiper-button-next'),
                prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    spaceBetween: 16,
                },
                768: {
                    spaceBetween: 24,
                }
            }
        });

        const resizeObserver = new ResizeObserver(() => {
            const newOffset = calcOffset();
            swiper.params.slidesOffsetBefore = newOffset;
            swiper.params.slidesOffsetAfter = newOffset;
            swiper.update();
        });

        resizeObserver.observe(document.body);
    });
}
